export class ObjectUtils {

    public static assign<T, U>(target: T, source: U, ignoredFields?: string[]): T {
        const clone: T = Object.assign(target, source);
        if (ignoredFields) {
            ignoredFields.forEach(ignoredField => delete clone[ignoredField]);
        }
        return clone;
    }
}
